<template>
  <component
    :is="direction === 'vertical' ? 'iColumn' : 'iRow'"
    v-bind="myLayoutProps"
    :align="direction === 'vertical' ? align : verticalAlign"
    :vertical-align="direction === 'vertical' ? verticalAlign : align"
  >
    <slot />
  </component>
</template>

<script>
import {
  LayoutElementMixinProduction,
} from "%/dynamic-component-editor/standard-elements/layouts/layout-element-mixin-production";
import LayoutAlign from "%/dynamic-component-editor/options/layout-align";
import LayoutAlignVertical from "%/dynamic-component-editor/options/layout-align-vertical";
import StaticLayoutDirection from "%/dynamic-component-editor/options/static-layout-direction";

export default {
  name: "Container",
  production: true,
  mixins: [LayoutElementMixinProduction],
  data() {
    return {
      LayoutAlign,
      LayoutAlignVertical,
      StaticLayoutDirection,
    };
  },
  computed: {
    direction() {
      return this.getOptionValue(StaticLayoutDirection);
    },
    myAlign() {
      return this.direction === "vertical" ? this.align : this.verticalAlign;
    },
    align() {
      const value = this.getOptionValue(LayoutAlign);
      if (this.direction === "vertical") {
        switch (value) {
          case "start":
            return "left";
          case "end":
            return "right";
          default:
            return "center";
        }
      } else {
        switch (value) {
          case "start":
            return "top";
          case "end":
            return "bottom";
          default:
            return "middle";
        }
      }
    },
    verticalAlign() {
      const value = this.getOptionValue(LayoutAlignVertical);
      if (this.direction === "vertical") {
        switch (value) {
          case "start":
            return "top";
          case "end":
            return "bottom";
          case "center":
            return "middle";
          case "between":
            return "between";
          case "around":
            return "around";
          case "evenly":
            return "evenly";
          default:
            return "top";
        }
      } else {
        switch (value) {
          case "start":
            return "left";
          case "end":
            return "right";
          case "center":
            return "center";
          case "between":
            return "between";
          case "around":
            return "around";
          case "evenly":
            return "evenly";
          default:
            return "left";
        }
      }
    },
  },
};
</script>
